// extracted by mini-css-extract-plugin
export default {"viewport":"GameLayout_viewport__Wq14t","stage":"GameLayout_stage__OL7Zp"};